import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const activitylogPdfTodo = createAsyncThunk('activitylogPdf', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'logs_pdf',
            data: {
                "startDate": data.startDate,
                'endDate': data?.endDate,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return res = { status: error?.response?.status, data: error?.response?.data };
    }
})




